'use client';
class HeadersInitializationError extends Error {
    constructor(cause){
        super('Некорректный формат заголовков', {
            cause
        });
        this.name = 'HeadersInitializationError';
        Object.setPrototypeOf(this, HeadersInitializationError.prototype);
    }
}

export { HeadersInitializationError };
//# sourceMappingURL=HeadersInitializationError.js.map
